// React
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injection
import { notifyError } from '../../containers/componentsInjection';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { APIClient } from '../../../../helpers/api_helper';
import { openPdfWithBase64 } from '../../../../utils/openPdfWithBase64';

// View
import { ProposalsByCredentialsNTPage } from './view';
import { ReportsInjection } from '../../containers/reportsInjection';

export const ProposalsByCredentialsNT = () => {
  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();

  const { getSpecialties, specialties } = ReportsInjection();

  useEffect(() => {
    getSpecialties();
  }, []);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      cityInput: '',
      neighborhood: '',
      company: '',
      specialties: [],
    },
    validationSchema: Yup.object({
      cityInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string().required(),
      }),
      neighborhood: Yup.string(),
      company: Yup.string(),
      specialties: Yup.array(),
    }),

    onSubmit: (values) => {
      let specialtiesArray = values.specialties.map((item) => {
        return item.value;
      });

      const valuesToSubmit = {
        city_id: Number(values.cityInput.value) || null,
        district: values.neighborhood || null,
        company_name: values.company?.trim() || null,
        specialities: specialtiesArray,
      };

      toggleLoading();
      api
        .create('/reports/register/provider', valuesToSubmit)
        .then((response) => {
          openPdfWithBase64(response.data, 'Rede Credenciada');
        })
        .catch((error) => {
          notifyError(error.response.data.messages.error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <ProposalsByCredentialsNTPage
      history={history}
      validation={validation}
      specialties={specialties}
      // Data
    />
  );
};
